import CryptoJS from 'crypto-js';

// A unique hash key for encryption (ensure you manage your keys securely)
const HASH_KEY = '4D8jPrAfI9uP68z9';

// Function to load and decrypt data from localStorage
export const loadStore = <T = unknown>(key: string): T | null => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, HASH_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData as T;
  } catch (e) {
    console.error('Error decrypting storage:', e);
    return null;
  }
};

// Function to encrypt and save data to localStorage
export const saveStore = <T = unknown>(key: string, value: T): void => {
  try {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), HASH_KEY).toString();
    localStorage.setItem(key, ciphertext);
  } catch (e) {
    console.error('Error encrypting storage:', e);
  }
};
